import { render } from "./Legend.vue?vue&type=template&id=aa8463d2"
import script from "./Legend.vue?vue&type=script&lang=js"
export * from "./Legend.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__